import React, { Component } from 'react';
import { getAboutData, updateBoard } from '../../services/aboutService';
import {
  FormLabel,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@material-ui/core';
import { ThemeProvider, createMuiTheme } from '@material-ui/core/styles';

let tempKeySeq = 0;
function nextTempKey() {
  tempKeySeq += 1;
  return `new-${tempKeySeq}`;
}

class BoardForm extends Component {
  state = {
    heading: '',
    members: [],
    saving: false,
    error: '',
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    this.loadBoard();
  }

  loadBoard = async () => {
    const result = await getAboutData();
    const board = result.data.board || { heading: '', members: [] };

    const members = (board.members || []).map((member) => ({
      key: member._id || nextTempKey(),
      name: member.name || '',
      title: member.title || '',
      alt: (member.image && member.image.alt) || '',
      paragraph: member.paragraph || '',
      file: (member.image && member.image.src) || '',
      originalSrc: (member.image && member.image.src) || '',
      selectedFile: null,
    }));

    this.setState({ heading: board.heading || '', members });
  };

  theme = createMuiTheme({
    typography: {
      fontFamily: "'Nunito', sans-serif",
      fontSize: 11.5,
    },
    palette: {
      primary: {
        main: '#00CCFF',
      },
      secondary: {
        main: '#00CCFF',
      },
    },
  });

  headingChangeHandler = (e) => {
    this.setState({ heading: e.target.value });
  };

  fieldChangeHandler = (e, index, field) => {
    const members = [...this.state.members];
    members[index] = { ...members[index], [field]: e.target.value };
    this.setState({ members });
  };

  fileSelectedHandler = (e, index) => {
    if (e.target.files.length === 0) return;

    const members = [...this.state.members];
    members[index] = {
      ...members[index],
      selectedFile: e.target.files[0],
      file: URL.createObjectURL(e.target.files[0]),
    };

    this.setState({ members });
  };

  positionChangeHandler = (e, index) => {
    const newPosition = parseInt(e.target.value, 10);
    const members = [...this.state.members];
    const [moved] = members.splice(index, 1);
    members.splice(newPosition - 1, 0, moved);
    this.setState({ members });
  };

  addMemberHandler = () => {
    const members = [...this.state.members];
    members.push({
      key: nextTempKey(),
      name: '',
      title: '',
      alt: '',
      paragraph: '',
      file: null,
      originalSrc: '',
      selectedFile: null,
    });
    this.setState({ members });
  };

  removeMemberHandler = (index) => {
    const member = this.state.members[index];
    const label = member.name || 'this board member';
    if (!window.confirm(`Remove ${label}?`)) return;

    const members = [...this.state.members];
    members.splice(index, 1);
    this.setState({ members });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const missingImage = this.state.members.find((member) => !member.file);
    if (missingImage) {
      this.setState({
        error: `"${missingImage.name || 'A board member'}" is missing an image.`,
      });
      return;
    }

    const setBoard = async () => {
      const formData = new FormData();
      formData.append('heading', this.state.heading);
      formData.append('count', this.state.members.length);

      this.state.members.forEach((member, index) => {
        formData.append(`src_${index}`, member.originalSrc || '');
        formData.append(`name_${index}`, member.name || '');
        formData.append(`title_${index}`, member.title || '');
        formData.append(`alt_${index}`, member.alt || '');
        formData.append(`paragraph_${index}`, member.paragraph || '');
        if (member.selectedFile)
          formData.append(
            `image_${index}`,
            member.selectedFile,
            member.selectedFile.name
          );
      });

      this.setState({ saving: true, error: '' });

      try {
        await updateBoard(formData);
        window.history.back();
      } catch (ex) {
        this.setState({ saving: false });
        console.log(ex); // TODO: take out? axios interceptor should handle unexpected errors.
      }
    };
    setBoard();
  };

  render() {
    const { heading, members, saving, error } = this.state;

    return (
      <ThemeProvider theme={this.theme}>
        <div className="margin-container-sm crud-form">
          <div className="crud-form-col">
            <h1>Board of Directors Form</h1>

            <form className="membership-form" onSubmit={this.handleSubmit}>
              <FormLabel
                style={{ fontSize: '1.1rem', fontWeight: 600, color: '#000' }}
              >
                Section Heading
              </FormLabel>
              <div className="input-wrap">
                <TextField
                  value={heading}
                  onChange={this.headingChangeHandler}
                  id="heading"
                  name="heading"
                  type="text"
                  label="Heading"
                  style={{ width: '100%' }}
                />
              </div>

              {members.map((member, index) => (
                <div className="input-wrap" key={member.key}>
                  <FormLabel
                    style={{ fontSize: '1.1rem', fontWeight: 600, color: '#000' }}
                  >
                    Board Member {index + 1}
                  </FormLabel>

                  <div className="img-upload">
                    <Button
                      className="img-upload-button"
                      variant="contained"
                      component="label"
                    >
                      Choose Image
                      <input
                        type="file"
                        hidden
                        onChange={(e) => this.fileSelectedHandler(e, index)}
                      />
                    </Button>
                    <div className="image-preview">
                      <img src={member.file} alt="" />
                    </div>
                  </div>

                  <TextField
                    value={member.alt}
                    onChange={(e) => this.fieldChangeHandler(e, index, 'alt')}
                    id={`alt-${index}`}
                    name={`alt-${index}`}
                    type="text"
                    label="Alternative Text"
                    style={{ marginTop: '1.5em', width: '100%' }}
                  />
                  <div
                    style={{ fontSize: '.8rem', fontWeight: '600', color: '#007bff' }}
                  >
                    Describe the image to a visually impaired person as{' '}
                    <span style={{ textDecoration: 'underline' }}>precisely</span> as
                    possible with as{' '}
                    <span style={{ textDecoration: 'underline' }}>few words</span>{' '}
                    as possible.
                  </div>

                  <FormControl style={{ marginTop: '2em' }}>
                    <InputLabel id={`position-label-${index}`}>
                      Position
                    </InputLabel>
                    <Select
                      labelId={`position-label-${index}`}
                      value={index + 1}
                      name={`position-${index}`}
                      onChange={(e) => this.positionChangeHandler(e, index)}
                      style={{ width: '150px' }}
                      inputProps={{ MenuProps: { disableScrollLock: true } }}
                    >
                      {members.map((_, i) => (
                        <MenuItem key={i} value={i + 1}>
                          {i + 1}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <TextField
                    value={member.name}
                    onChange={(e) => this.fieldChangeHandler(e, index, 'name')}
                    id={`name-${index}`}
                    name={`name-${index}`}
                    type="text"
                    label="Name"
                    style={{ marginTop: '2em', width: '100%' }}
                  />
                  <TextField
                    value={member.title}
                    onChange={(e) => this.fieldChangeHandler(e, index, 'title')}
                    id={`title-${index}`}
                    name={`title-${index}`}
                    type="text"
                    label="Title / Position"
                    style={{ marginTop: '2em', width: '100%' }}
                  />
                  <TextField
                    value={member.paragraph}
                    onChange={(e) =>
                      this.fieldChangeHandler(e, index, 'paragraph')
                    }
                    id={`paragraph-${index}`}
                    name={`paragraph-${index}`}
                    type="text"
                    label="Board Copy"
                    multiline
                    rows={5}
                    rowsMax={10}
                    style={{ marginTop: '2em', width: '100%' }}
                  />

                  <div
                    onClick={() => this.removeMemberHandler(index)}
                    className="admin-btn admin-btn-delete"
                    style={{ marginTop: '1em' }}
                  >
                    Remove
                  </div>
                </div>
              ))}

              <div
                onClick={this.addMemberHandler}
                className="admin-btn admin-btn-create"
                style={{ marginTop: '1em' }}
              >
                Add Board Member
              </div>

              {error && (
                <div style={{ fontSize: '.9rem', fontWeight: '600', color: '#f44336', marginTop: '1.5em' }}>
                  {error}
                </div>
              )}

              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={saving}
                style={{
                  display: 'block',
                  borderRadius: '4px',
                  marginTop: '1.5em',
                  width: '200px',
                  height: '50px',
                  fontSize: '1.1rem',
                  fontWeight: '600',
                }}
              >
                Save
              </Button>
            </form>
          </div>
        </div>
      </ThemeProvider>
    );
  }
}

export default BoardForm;
